import {sseRequest} from '@crema/services/auth/jwt-auth';
import AddDataUI from './AddDataUI';
import {useState} from 'react';
import {useIntl} from 'react-intl';
import AppInfoView from '@crema/core/AppInfoView';
import {fetchError, showMessage} from 'redux/actions';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';

const AddDataGL = ({customerId}) => {
  const dispatch = useDispatch();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const {messages} = useIntl();
  const [doneStatusCount, setDoneStatusCount] = useState(0);
  const [allStatusCount, setAllStatusCount] = useState(0);
  const [errorStatusCount, setErrorStatusCount] = useState(0);
  const [errorData, setErrorData] = useState([]);
  const [fileName, setFileName] = useState('');
  const [clientAssignmentDoneCount, setClientAssignmentDoneCount] = useState(0);
  const [clientAssignmentAllCount, setClientAssignmentAllCount] = useState(0);
  const [clientAssignmentErrorCount, setClientAssignmentErrorCount] =
    useState(0);
  const [clientAssignmentErrorData, setClientAssignmentErrorData] = useState(
    [],
  );

  const sendFile = async () => {
    console.log();
    if (!uploadedFiles || !uploadedFiles.length) {
      dispatch(fetchError('one file only'));
      return;
    }
    if (uploadedFiles.length > 1) {
      dispatch(fetchError('one file only'));
      return;
    }
    const fileExtention = uploadedFiles[0].name.split('.')[1];
    setFileName(uploadedFiles[0].name.split('.')[0]);
    if (
      !(
        fileExtention.includes('xlsx') ||
        fileExtention.includes('xlsm') ||
        fileExtention.includes('xlsb') ||
        fileExtention.includes('xltx') ||
        fileExtention.includes('xltm') ||
        fileExtention.includes('xls') ||
        fileExtention.includes('xlt') ||
        fileExtention.includes('xls') ||
        fileExtention.includes('xml') ||
        fileExtention.includes('xml') ||
        fileExtention.includes('xlam') ||
        fileExtention.includes('xla') ||
        fileExtention.includes('xlw') ||
        fileExtention.includes('xlr')
      )
    ) {
      dispatch(fetchError('this file not supported'));
      return;
    }
    // create a new FormData object and append the file to it
    const formData = new FormData();
    formData.append('myfile', uploadedFiles[0]);
    console.log('customer Id');
    console.log(customerId);

    setIsLoading(true);
    setIsClicked(true);
    // Reset counts
    setDoneStatusCount(0);
    setAllStatusCount(0);
    setErrorStatusCount(0);
    setErrorData([]);
    setClientAssignmentDoneCount(0);
    setClientAssignmentAllCount(0);
    setClientAssignmentErrorCount(0);
    setClientAssignmentErrorData([]);

    sseRequest(`data/upload-file-Client/${customerId}`, {
      body: formData,
      onmessage: (message) => {
        console.log(message);
        if (message.event.includes('doneUploadData')) {
          const messageData = JSON.parse(message.data);

          if (
            messageData.status === 'duplicate_sent' ||
            messageData.status === 'duplicate_free'
          ) {
            setErrorStatusCount((prev) => prev + 1);
            setAllStatusCount((prev) => prev + 1);
            setErrorData((prev) => {
              const duplicateData = remanageDataError(message.data);
              duplicateData.error = 'Duplicate entry';
              prev.push(duplicateData);
              return prev;
            });
          } else {
            setAllStatusCount((prev) => prev + 1);
            setDoneStatusCount((prev) => prev + 1);
          }
        } else if (message.event.includes('errorUploadData')) {
          setErrorStatusCount((prev) => prev + 1);
          setAllStatusCount((prev) => prev + 1);
          setErrorData((prev) => {
            prev.push(remanageDataError(message.data));
            return prev;
          });
        } else if (message.event.includes('doneClientAssignment')) {
          setClientAssignmentAllCount((prev) => prev + 1);
          setClientAssignmentDoneCount((prev) => prev + 1);
        } else if (message.event.includes('errorClientAssignment')) {
          setClientAssignmentErrorCount((prev) => prev + 1);
          setClientAssignmentAllCount((prev) => prev + 1);
          setClientAssignmentErrorData((prev) => {
            prev.push(remanageDataError(message.data));
            return prev;
          });
        } else if (message.event.includes('archivingFinished')) {
          const data = JSON.parse(message.data);
          dispatch(
            showMessage(
              data.message || 'Reports and archives created successfully',
            ),
          );
        }
      },
      onclose: () => {
        setIsLoading(false);
      },
      onerror: (error) => {
        dispatch(fetchError('failed:' + error?.message));
        setIsLoading(false);
      },
    });
  };

  const remanageDataError = (string) => {
    const jsonParsed = JSON.parse(string); // parses entire string to object

    let data;

    if (typeof jsonParsed.data === 'string') {
      try {
        data = JSON.parse(jsonParsed.data); // parses string if needed
      } catch {
        data = jsonParsed.data;
      }
    } else {
      data = jsonParsed.data; // already an object
    }

    // attach error info safely
    data.error = jsonParsed.error || jsonParsed.originalErrorData || null;

    return data;
  };

  return (
    <>
      <AppInfoView />
      <AddDataUI
        fileName={fileName}
        isClicked={isClicked}
        allStatusCount={allStatusCount}
        sendDataLoading={isLoading}
        setUploadedFiles={setUploadedFiles}
        functionToRun={sendFile}
        messages={messages}
        doneStatusCount={doneStatusCount}
        errorStatusCount={errorStatusCount}
        uploadedFiles={uploadedFiles}
        errorsRows={errorData}
        clientAssignmentDoneCount={clientAssignmentDoneCount}
        clientAssignmentAllCount={clientAssignmentAllCount}
        clientAssignmentErrorCount={clientAssignmentErrorCount}
        clientAssignmentErrorsRows={clientAssignmentErrorData}
      />
    </>
  );
};
export default AddDataGL;
AddDataGL.propTypes = {
  customerId: PropTypes.number.isRequired,
};
